/* Shows label if image is original */
export function originalLabel({ original }: { original?: boolean }) {
  if (!original) return null
  return <span className="bg-gray-200 py-0.5 px-1.5 rounded text-gray-500 ml-1">Original</span>
}
